/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, checkValidation } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
// eslint-disable-next-line
import { Row, Col, Button } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const LinkedinField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [inputField, setInputField] = useState({
		linkedin: ''
	});
	const [validation, setValidation] = useState({
		error_linkedin: ''
	});

	useEffect(() => {
		if (props.id) {
			const { linkedin } = lodgeData.social;
			setInputField({ ...inputField, linkedin });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};
	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;
		var checkError = checkValidation(inputField.linkedin, 'url');
		if (!inputField.linkedin) {
			errors.error_linkedin = pageLanguageContent['CLD071'];
			errorCount++;
		} else if (!checkError) {
			errors.error_linkedin = pageLanguageContent['CLD077'];
			errorCount++;
		} else {
			errors.error_linkedin = '';
		}
		var sendData = {};
		sendData['value'] = inputField['linkedin'];
		sendData['type'] = 'Linkedin';
		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('social', inputField['linkedin'], 'linkedin', '');
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}
	return (
		<Row className='mt-2'>
			<Col lg={12}>
				<FormGroupInput
					id='linkedin'
					label={pageLanguageContent['CLD152'] ? pageLanguageContent['CLD152'] : ''}
					placeholder={pageLanguageContent['CLD184'] ? pageLanguageContent['CLD184'] : ''}
					type='text'
					name='linkedin'
					onChange={inputsHandler}
					value={inputField.linkedin}
				/>
				{validation.error_linkedin && <p className='formValidationError'>{validation.error_linkedin}</p>}
			</Col>
			<Col lg={12}>
				{inputField.linkedin && (
					<p style={{ position: 'absolute' }}>
						<a
							href={inputField.linkedin}
							target='_blank'
							rel='noopener noreferrer'
							data-toggle='tooltip'
							title={inputField.linkedin}
						>
							{pageLanguageContent['CLD190'] ? pageLanguageContent['CLD190'] : ''}
						</a>
					</p>
				)}
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default LinkedinField;
